module.exports = __webpack_public_path__ + "img/swipe_hand.1cdb9133.svg";